import { jsx as _jsx } from "react/jsx-runtime";
import { Prompt } from '@coveord/plasma-mantine';
import { Locales } from '../../../strings/Locales.js';
export var EditConfirmationPromptCancelButton = function EditConfirmationPromptCancelButton(param) {
    var onClick = param.onClick, loading = param.loading;
    return /*#__PURE__*/ _jsx(Prompt.CancelButton, {
        onClick: onClick,
        loading: loading,
        children: Locales.format('EditConfirmationPrompt.footer.button.cancel')
    });
};
EditConfirmationPromptCancelButton.displayName = 'EditConfirmationPrompt.CancelButton';

//# sourceMappingURL=EditConfirmationPromptCancelButton.js.map